import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import SelectComponent from '../select/SelectComponent';
import { inMilliseconds } from '../../../utils/commonFunctions';

// Kept static (untranslated text) for consumers like RunDetails.tsx that only
// ever match on the language-invariant `value` field (e.g. '1h'), never `text`.
export const durationOptions = [
    { id: 11, text: 'Complete Run', value: '' },
    { id: 0, text: '1 minute', value: '1m' },
    { id: 1, text: '2 minutes', value: '2m' },
    { id: 2, text: '3 minutes', value: '3m' },
    { id: 3, text: '5 minutes', value: '5m' },
    { id: 4, text: '10 minutes', value: '10m' },
    { id: 5, text: '30 minutes', value: '30m' },
    { id: 6, text: '1 hour', value: '1h' },
    { id: 7, text: '2 hours', value: '2h' },
    { id: 8, text: '3 hours', value: '3h' },
    { id: 9, text: '6 hours', value: '6h' },
    { id: 10, text: '12 hours', value: '12h' },
];

// Translated counterpart for anything that renders/matches on `text` — SelectComponent
// maps `text` to both the antd Option value and its disabledOptions matching, so this
// must recompute (and any consumer's cached entries must be re-derived) on language change.
export const useDurationOptions = () => {
    const { t } = useTranslation();
    return [
        { id: 11, text: t('shared.duration.completeRun'), value: '' },
        { id: 0, text: t('shared.duration.oneMinute'), value: '1m' },
        { id: 1, text: t('shared.duration.twoMinutes'), value: '2m' },
        { id: 2, text: t('shared.duration.threeMinutes'), value: '3m' },
        { id: 3, text: t('shared.duration.fiveMinutes'), value: '5m' },
        { id: 4, text: t('shared.duration.tenMinutes'), value: '10m' },
        { id: 5, text: t('shared.duration.thirtyMinutes'), value: '30m' },
        { id: 6, text: t('shared.duration.oneHour'), value: '1h' },
        { id: 7, text: t('shared.duration.twoHours'), value: '2h' },
        { id: 8, text: t('shared.duration.threeHours'), value: '3h' },
        { id: 9, text: t('shared.duration.sixHours'), value: '6h' },
        { id: 10, text: t('shared.duration.twelveHours'), value: '12h' },
    ];
};

export const getSelectedTimeDurationInMs = (record, selectedTimeDuration) => selectedTimeDuration ? inMilliseconds(selectedTimeDuration) : dayjs(record.timeEnd).diff(record.timeStart, 'ms');

const DurationDropdown = ({
    onTimeDurationChange,
    selectedTimeDuration,
    disabledDurationOptions,
}) => {
    const { t } = useTranslation();
    const translatedDurationOptions = useDurationOptions();
    return (
        <>
        <SelectComponent
            className='durationSelect'
            placeholder={t('shared.duration.selectPlaceholder')}
            filterSort={false}
            options={translatedDurationOptions}
            onChangeEvent={onTimeDurationChange}
            value={selectedTimeDuration?.text ?? t('shared.duration.oneHour')}
            disabledOptions={disabledDurationOptions}
        />
        </>
    );
};

export default DurationDropdown;
